import Vue from 'vue'
import Vuex from 'vuex'
import { slice } from '@/util/object'

Vue.use(Vuex)

const keyUserManageConds = 'userManageConds'

const defaultUserManageConds = {
  sortType: false,
  page: 1,
  range: 0,
  cate_id: 0,
  keyword: ''
}

const state = {
  token: '',
  uname: '',
  title: '',
  logo: '',
  tel: '',
  head_color: '',
  isCeping: false,
  role: '',
  is_up_pack: 0,
  userManageConds: (() => {
    const json = localStorage.getItem(keyUserManageConds)
    const data = JSON.parse(json) || { ...defaultUserManageConds }
    return data
  })()
}

const mutations = {
  setValue(state, obj) {
    if (typeof obj === 'object') {
      Object.keys(obj).forEach(v => {
        state[v] = obj[v]
      })
    }
  },

  logout(state) {
    store.commit('setValue', {
      token: '',
      uname: '',
      role: '',
      isCeping: false,
    })
  },

  setUserManageConds(state, value) {
    const keys = Object.keys(defaultUserManageConds)
    const data = slice(value, keys)
    state.userManageConds = data
    // 将查询条件保存在本地存储
    localStorage.setItem(keyUserManageConds, JSON.stringify(data))
  }
}

const store = new Vuex.Store({
  state,
  mutations,
})

const user = localStorage.getItem('user')
if (user) {
  try {
    store.commit('setValue', JSON.parse(user))
  } catch (error) {
    console.log('~~~ restore user error', error)
  }
}

/**
 * 获取或设置课程库保存的搜索条件
 * @param value
 */
export function userManageConds(value) {
  if (value === undefined) {
    return store.state.userManageConds
  }
  store.commit('setUserManageConds', value)
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js